'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Generates a random key to make React happy (shouldn't be used for anything else).
 *
 * @returns string
 */ const generateKey = ()=>{
    return Math.random().toString(16).slice(2);
};

exports.generateKey = generateKey;
//# sourceMappingURL=key.js.map
